// eslint-disable-next-line
import {
	UserLayout,
	BasicLayout,
	DirectLayout,
	RouteView,
	BlankLayout,
	PageView
} from '@/layouts'

import {
	brand,
	defaultBrand
} from '@/config/brand.config'

// 获取主机名、端口号（如：192.168.3.67:8000）
const domain = window.location.host

const customBrand = brand.find(item => {
	return item.domain.includes(domain)
})

const currentBrand = customBrand || defaultBrand
//console.log(currentBrand.extend.includes('HideWorkplace') ? '/dashboard-new/battle' : '/dashboard/workplace')

export const asyncRouterMap = [
	{
		path: '/',
		name: 'index',
		component: BasicLayout,
		meta: {
			title: '首页',
		},
		// (/device/list)：客户端列表的路由；（/dashboard/workplace）：工作台的路由
		redirect: currentBrand.extend.includes('HideWorkplace') ? '/device/list' : '/dashboard/workplace',
		children: [
			{
				path: '/dashboard/workplace',
				name: 'Workplace',
				//hidden: currentBrand.extend.includes('HideWorkplace'),
				component: () => import('@/views/dashboard/Workplace'),
				meta: {
					title: '工作台',
					keepAlive: true,
					icon: 'laptop',
				},
			},
			{
				path: '/dashboard',
				component: RouteView,
				meta: {
					title: '作战室',
					icon: 'radar-chart',
				},
				children: [
					{
						path: '/dashboard/battle',
						name: 'Battle2',
						hidden: currentBrand.extend.includes('HideBattle'),
						component: () => import('@/views/dashboard/Battle'),
						meta: {
							title: '作战室-基础',
							keepAlive: true,
							icon: 'radar-chart',
						},
					},
					{
						path: `http://zzs.nianchu.net/#/?token=`,
						name: 'Battle',
						hidden: currentBrand.extend.includes('HideBattle'),
						meta: {
							title: '作战室-宏观',
							target: '_blank',
							icon: 'radar-chart',
						},
					},
				]
			},
			// 设备管理
			{
				path: '/device/list',
				name: 'DeviceList',
				hidden: currentBrand.extend.includes('HideBattle'),
				component: () => import('@/views/device/list'),
				meta: {
					title: '客户端列表',
					keepAlive: true,
					icon: 'robot'
				},
			},
			// {
			// 	path: '/plugin/superprice',
			// 	name: 'superprice',
			// 	component: () => import('@/views/plugin/superprice'),
			// 	meta: {
			// 		title: '限时活动功能',
			// 		keepAlive: true,
			// 		icon: 'dollar',
			// 	},
			// },
			{
				path: `${currentBrand.im_app}`,
				name: 'Server',
				hidden: !currentBrand.extend.includes('UseServer'),
				meta: {
					title: '客服',
					target: '_blank',
					icon: 'message',
				},
			},
			// 联盟管理
			{
				path: '/company',
				redirect: '/company/taobao',
				component: RouteView,
				meta: {
					title: '联盟管理',
					icon: 'bank'
				},
				children: [
					{
						path: '/company/taobao',
						name: 'CompanyTaobaoList',
						component: () => import('@/views/company/taobao/list'),
						hidden: currentBrand.extend.includes('HideCompanyTaobao'),
						meta: {
							title: '淘宝联盟',
							keepAlive: true,
						},
					},
					{
						path: '/company/jingdong',
						name: 'CompanyJingdongList',
						component: () => import('@/views/company/jingdong/list'),
						meta: {
							title: '京东联盟',
							keepAlive: true,
						},
					},
					{
						path: '/company/chuanshanjia',
						name: 'CompanyChuanshanjiaList',
						component: () => import('@/views/company/chuanshanjia/list'),
						meta: {
							title: '穿山甲',
							keepAlive: true,
						},
					},
					{
						path: '/company/jingyong',
						name: 'CompanyJingyongList',
						component: () => import('@/views/company/jingyong/list'),
						hidden: currentBrand.extend.includes('HideCompanyJingyong'),
						meta: {
							title: '京佣联盟',
							keepAlive: true,
						},
					},
					{
						path: '/company/douyin/list',
						name: 'CompanyDouyinList',
						component: () => import('@/views/company/douyin/list'),
						meta: {
							title: '精选联盟',
							keepAlive: true,
						},
					},
					{
						path: '/company/pinduoduo/list',
						name: 'CompanyPinduoduoList',
						component: () => import('@/views/company/pinduoduo/list'),
						hidden: currentBrand.extend.includes('HideCompanyPinduoduoList'),
						meta: {
							title: '多多进宝',
							keepAlive: true,
						},
					},

					{
						path: '/company/weipinhui/list',
						name: 'CompanyWeipinhuiList',
						component: () => import('@/views/company/weipinhui/list'),
						hidden: currentBrand.extend.includes('HideCompanyWeipinhuiList'),
						// hidden: currentBrand.extend.includes('HideBug'),
						// permission: ['debug']
						meta: {
							title: '唯品会联盟',
							keepAlive: true
						},
					},
					{
						path: '/company/dxz/list',
						name: 'CompanyDxzList',
						component: () => import('@/views/company/dxz/list'),
						hidden: currentBrand.extend.includes('HideCompanyDxzList'),
						meta: {
							title: '小程序',
							keepAlive: true
						},
					},
					{
						path: '/company/mgmovie/list',
						name: 'CompanyMgmovieList',
						component: () => import('@/views/company/mgmovie/list'),
						// hidden: currentBrand.extend.includes('HideCompanyMgmovieList'),
						meta: {
							title: '芒果电影票',
							keepAlive: true
						},
					},
					{
						path: '/company/hxwl/list',
						name: 'CompanyHxwlList',
						component: () => import('@/views/company/hxwl/list'),
						// hidden: currentBrand.extend.includes('HideCompanyMgmovieList'),
						meta: {
							title: '欢喜物流',
							keepAlive: true
						},
					},
					{
						path: '/company/jingxituan',
						name: 'CompanyJxtuanList',
						component: () => import('@/views/company/jingxituan/list'),
						meta: {
							title: '京喜团',
							keepAlive: true,
						},
					},
				],
			},
			// 会员管理
			{
				path: '/fans',
				component: RouteView,
				meta: {
					title: '粉丝管理',
					icon: 'user'
				},
				children: [
					{
						path: '/fans/newfans',
						component: () => import('@/views/fans/newfans'),
						name: 'NewFans',
						meta: {
							title: '新的粉丝',
							keepAlive: true,
						},
					},
					{
						path: '/fans/list',
						component: () => import('@/views/fans/list'),
						name: 'FansList',
						meta: {
							title: '会员列表',
							keepAlive: true,
						},
					},
					{
						path: '/fans/inactive',
						component: () => import('@/views/fans/inactive'),
						name: 'FansInactive',
						meta: {
							title: '僵尸粉列表',
							keepAlive: true,
						},
					},
					{
						path: '/fans/wxlist',
						name: 'FansWxlist',
						component: () => import('@/views/fans/wxlist'),
						meta: {
							title: '通讯录列表',
							keepAlive: true,
						},
					},
					{
						path: '/grouppush/tasklist',
						component: () => import('@/views/grouppush/tasklist'),
						name: 'GrouppushTasklist',
						meta: {
							title: '群发任务',
							keepAlive: false,
						},
					},
				],
			},
			// 群组管理
			{
				path: '/usergroup',
				component: RouteView,
				hidden: currentBrand.extend.includes('HideGroup'),
				meta: {
					title: '群组管理',
					icon: 'team',
				},
				children: [
					{
						path: '/usergroup/list',
						name: 'UsergroupList',
						component: () => import('@/views/usergroup/list'),
						meta: {
							title: '所有群组',
							keepAlive: true,
						},
					},
					{
						path: '/usergroup/applylist',
						name: 'UsergroupApplylist',
						component: () => import('@/views/usergroup/applylist'),
						meta: {
							title: '返利群组',
							keepAlive: true,
						},
					},
					{
						path: '/lucky/index',
						name: 'LotteryIndex',
						component: () => import('@/views/lucky/index'),
						meta: {
							title: '抽奖中心',
							keepAlive: true
						},
					},
				],
			},
			// 订单管理
			{
				path: '/order',
				redirect: '/order/taobao',
				component: RouteView,
				hidden: true,
				meta: {
					title: '订单管理(已停用)',
					icon: 'profile',
				},
				children: [
					{
						path: '/order/taobao',
						name: 'OrderTaobao',
						component: () => import('@/views/order/taobao/list'),
						meta: {
							title: '淘宝订单',
							keepAlive: true,
						},
					},
					{
						path: '/order/jingdong',
						name: 'OrderJingdong',
						component: () => import('@/views/order/jingdong/list'),
						meta: {
							title: '京东订单',
							keepAlive: true,
						},
					},
					{
						path: '/order/pinduoduo',
						name: 'OrderPinduoduo',
						component: () => import('@/views/order/pinduoduo/list'),
						meta: {
							title: '拼多多订单',
							keepAlive: true,
						},
					},
				],
			},
			{
				path: '/order-new',
				redirect: '/order-new/taobao',
				component: RouteView,
				// hidden: currentBrand.extend.includes('HideBug'),
				meta: {
					title: '订单管理',
					icon: 'profile',
				},
				children: [
					{
						path: '/order-new/taobao',
						name: 'OrderTaobaoNew',
						component: () => import('@/views/order-new/taobao/list'),
						hidden: currentBrand.extend.includes('HideOrder-newTaobao'),
						meta: {
							title: '淘宝联盟订单',
							keepAlive: true,
						},
					},
					{
						path: '/order-new/jingdong',
						name: 'OrderJingdongNew',
						component: () => import('@/views/order-new/jingdong/list'),
						meta: {
							title: '京东联盟订单',
							keepAlive: true,
						},
					},
					{
						path: '/order-new/chuanshanjia',
						name: 'OrderChuanShanJiaNew',
						component: () => import('@/views/order-new/chuanshanjia/list'),
						meta: {
							title: '穿山甲订单',
							keepAlive: true,
						},
					},
					{
						path: '/order-new/pinduoduo',
						name: 'OrderPinduoduoNew',
						component: () => import('@/views/order-new/pinduoduo/list'),
						hidden: currentBrand.extend.includes('HideOrder-newPinduoduo'),
						meta: {
							title: '多多进宝订单',
							keepAlive: true,
						},
					},
					{
						path: '/order-new/douyin',
						name: 'OrderDouyinNew',
						component: () => import('@/views/order-new/douyin/list'),

						meta: {
							title: '精选联盟订单',
							keepAlive: true,
						},
					},
					{
						path: '/order-new/douyinDistributionOrder',
						name: 'douyinDistributionOrder',
						component: () => import('@/views/order-new/douyinDistributionOrder/list'),

						meta: {
							title: '抖音分销订单',
							keepAlive: true,
						},
					},
					{
						path: '/order-new/weipinhui',
						name: 'OrderWeipinhuiNew',
						component: () => import('@/views/order-new/weipinhui/list'),
						hidden: currentBrand.extend.includes('HideOrder-newWeipinhui'),
						meta: {
							title: '唯品会联盟订单',
							keepAlive: true,
						},
					},
					{
						path: '/order-new/mgmovie',
						name: 'OrderMgmovie',
						component: () => import('@/views/order-new/mgmovie/list'),
						meta: {
							title: '芒果电影票订单',
							keepAlive: true,
						},
					},
					{
						path: '/order-new/hxwl',
						name: 'OrderHxwl',
						component: () => import('@/views/order-new/hxwl/list'),
						meta: {
							title: '欢喜物流订单',
							keepAlive: true,
						},
					},
				],
			},
			// 财务管理
			{
				path: '/capital',
				component: RouteView,
				meta: {
					title: '财务中心',
					icon: 'pay-circle',
				},
				children: [
					{
						path: '/payment/index',
						component: () => import('@/views/payment/index'),
						name: 'PaymentIndex',
						meta: {
							title: '提现配置',
							keepAlive: true,
						},
					},
					{
						path: '/capital/list',
						name: 'CapitalList',
						component: () => import('@/views/capital/list'),
						meta: {
							title: '提现列表',
							keepAlive: true,
						},
					},
					{
						path: '/capital/log',
						name: 'CapitalLog',
						component: () => import('@/views/capital/log'),
						meta: {
							title: '财产日志',
							keepAlive: true,
						},
					},
				],
			},


			{
				path: '/pyq',
				name: 'PYQ',
				component: RouteView,
				meta: {
					title: '自动朋友圈',
					icon: 'notification'
				},
				children: [
					{
						path: '/pyq/cfg',
						name: 'pyqCfg',
						meta: {
							title: '功能配置'
						},
						component: () => import('@/views/pyq/config'),
					},
					{
						path: '/pyq/message',
						name: 'pyqMessage',
						meta: {
							title: '评论模板'
						},
						component: () => import('@/views/pyq/messageList'),
					},
					{
						path: '/pyq/edit',
						name: 'editTaskList',
						hidden: true,
						meta: {
							title: '编辑配置'
						},
						component: () => import('@/views/pyq/modules/EditTask'),
					},
					{
						path: '/pyq/select',
						name: 'PyqSelect',
						meta: {
							title: '选品发圈'
						},
						component: () => import('@/views/pyq/select'),
					},
					{
						path: '/pyq/list',
						name: 'pyqList',
						meta: {
							title: '发圈列表'
						},
						component: () => import('@/views/pyq/list'),
					},

					{
						path: '/pyq/send',
						name: 'pyqConfig',
						meta: {
							title: '自定内容发圈',
						},
						component: () => import('@/views/pyq/index'),
					},
				],
			},
			{
				path: '/chuyu',
				name: 'ChuYu',
				component: () => import('@/views/chuyu/ChuYu'),
				hidden: false,
				meta: {
					title: '初语客服系统',
					keepAlive: true,
					icon: 'smile',
				},
			},
			// 基础设置
			{
				path: '/basic/setting',
				component: () => import('@/views/settings/BasicSetting'),
				name: 'BasicSetting',
				hidden: currentBrand.extend.includes('HideBasic'),
				meta: {
					title: '基础设置',
					icon: 'setting',
					keepAlive: true,
					hideChildrenInMenu: false,
				},
			},
			// 功能管理
			{
				path: '/plugin',
				component: RouteView,
				hidden: currentBrand.extend.includes('HidePlugin'),
				meta: {
					title: '功能模块设置',
					icon: 'api',
				},
				children: [
					{
						path: '/plugin/signin',
						name: 'PluginSignin',
						component: () => import('@/views/plugin/signin'),
						meta: {
							title: '签到奖励',
							keepAlive: true,
						},
					},
					{
						path: '/plugin/ticket',
						name: 'PluginTicket',
						component: () => import('@/views/plugin/ticket'),
						meta: {
							title: '查券功能',
							keepAlive: true,
						},
					},
					{
						path: '/plugin/vipvideo',
						name: 'PluginVipvideo',
						component: () => import('@/views/plugin/vipvideo'),
						meta: {
							title: '视频解析',
							keepAlive: true,
						},
					},
					{
						path: '/plugin/conduct',
						name: 'PluginConduct',
						component: () => import('@/views/plugin/conduct'),
						meta: {
							title: '推广裂变',
							keepAlive: true,
						},
					},
					{
						path: '/plugin/poster',
						name: 'PluginPoster',
						component: () => import('@/views/plugin/poster'),
						meta: {
							title: '海报分享',
							keepAlive: true,
						},
					},
					{
						path: '/plugin/guide',
						name: 'PluginGuide',
						component: () => import('@/views/plugin/guide'),
						meta: {
							title: '导购商城',
							keepAlive: true,
						},
					},
					{
						path: '/plugin/account',
						name: 'PluginAccount',
						component: () => import('@/views/plugin/account'),
						meta: {
							title: '账户安全',
							keepAlive: true,
						},
					},
					{
						path: '/plugin/token',
						name: 'PluginToken',
						hidden: currentBrand.extend.includes('HideToken'),
						component: () => import('@/views/plugin/token'),
						meta: {
							title: '积分奖励',
							keepAlive: true,
						},
					},
				],
			},
			// 回复设置
			{
				path: '/dialogue/settings',
				component: () => import('@/views/dialogue/settings'),
				name: 'DialogueSettings',
				hidden: currentBrand.extend.includes('HideDialogue'),
				meta: {
					title: '回复文案设置',
					icon: 'message',
					keepAlive: true,
					hideChildrenInMenu: false
				},
			},
			// 返利管理
			{
				path: '/rebate/settings',
				name: 'RebateSettings',
				component: () => import('@/views/rebate/settings'),
				hidden: currentBrand.extend.includes('HideRebateSettings'),
				meta: {
					title: '返利比例设置',
					keepAlive: true,
					icon: 'money-collect'
				},
				// children: [
				//   {
				//     path: '/rebate/settings',
				//     name: 'RebateSettings',
				//     component: () => import('@/views/rebate/settings'),
				//     meta: { title: '返利设置', keepAlive: true }
				//   }
				// ]
			},
			// 智能问答
			{
				path: '/dialogue/questions',
				component: () => import('@/views/dialogue/questions'),
				name: 'DialogueQuestions',
				hidden: currentBrand.extend.includes('HideQuestions'),
				meta: {
					title: '智能问答回复',
					icon: 'bulb',
					keepAlive: true,
					hideChildrenInMenu: false,
				},
			},


			//查券记录
			{
				path: '/coupon/log',
				name: 'CouponLog',
				// hidden: currentBrand.extend.includes('HideBattle'),
				component: () => import('@/views/coupon-log/log'),
				meta: {
					title: '查券记录',
					keepAlive: true,
					icon: 'profile'
				},
			},
			{
				path: '/device/setting/:id',
				hidden: true,
				component: () => import('@/views/device/settings'),
				meta: {
					title: '机器人设置',
					keepAlive: true
				},
			},

			// 会员详情
			{
				path: '/fans/detail/:robotid/:uid',
				component: () => import('@/views/fans/detail/Index'),
				hidden: true,
				meta: {
					title: '会员详情',
					icon: 'user',
					keepAlive: true,
					hideChildrenInMenu: false,
				},
			},

			// 免单活动
			{
				path: '/activity',
				component: RouteView,
				//hidden: currentBrand.extend.includes('HideFree'),
				meta: {
					title: '免单活动',
					icon: 'fire',
				},
				children: [
					{
						path: '/activity/goodslist',
						name: 'ActivityGoodslist',
						component: () => import('@/views/activity/goodslist'),
						meta: {
							title: '商品管理',
							keepAlive: true,
						},
					},
					{
						path: '/activity/activitylist',
						name: 'ActivityActivitylist',
						component: () => import('@/views/activity/activitylist'),
						meta: {
							title: '活动管理',
							keepAlive: true,
						},
					},
				],
			},

			// 更多功能
			{
				path: '/tripartite',
				component: RouteView,
				hidden: currentBrand.extend.includes('HideMore'),
				meta: {
					title: '更多功能',
					icon: 'experiment',
				},
				children: [
					{
						path: '/tripartite/weiquan',
						component: () => import('@/views/tripartite/weiquan'),
						hidden: !currentBrand.spread,
						name: 'TripartiteWeiquan',
						hidden: true,
						meta: {
							title: '维权订单助手',
							keepAlive: true,
						},
					},
					{
						path: '/characteristic/blacklist',
						name: 'CharacteristicBlacklist',
						component: () => import('@/views/characteristic/blacklist'),
						meta: {
							title: '会员黑名单',
							keepAlive: false,
						},
					},
					{
						path: '/characteristic/extend',
						name: 'CharacteristicExtend',
						component: () => import('@/views/characteristic/extend'),
						meta: {
							title: '拓展配置',
							keepAlive: false,
						},
					},
					{
						path: '/characteristic/taoshopblacklist',
						name: 'CharacteristicTaoshopblacklist',
						component: () => import('@/views/characteristic/taoshopblacklist'),

						meta: {
							title: '店铺黑名单',
							keepAlive: false,
						},
					},
					{
						path: '/innovate/ecc',
						name: 'InnovateEcc',
						component: () => import('@/views/innovate/ecc'),
						hidden: true,
						meta: {
							title: '收益倍增',
							keepAlive: true,
						},
					},
					{
						path: '/tripartite/fentu',
						component: () => import('@/views/tripartite/fentu'),
						hidden: currentBrand.menu_fentu_hidden,
						name: 'TripartiteFentu',
						hidden: true,
						meta: {
							title: '粉兔朋友圈助手',
							keepAlive: true,
						},
					},
					{
						path: '/tripartite/yingpiao',
						component: () => import('@/views/tripartite/yingpiao'),
						hidden: true,
						name: 'TripartiteYingpiao',
						meta: {
							title: '影票CPS模块（内测）',
							keepAlive: true,
						},
					},
				],
			},

			// 推广中心
			{
				path: '/conduct/center',
				name: 'ConductCenter',
				component: () => import('@/views/conduct/center'),
				hidden: true,
				meta: {
					title: '推广中心',
					keepAlive: false,
				},
			},
			// 我的资产
			{
				path: '/property/center',
				name: 'PropertyCenter',
				component: () => import('@/views/property/center'),
				hidden: true,
				meta: {
					title: '我的资产',
					keepAlive: false,
				},
			},
			// 应用市场
			{
				path: '/market',
				name: 'Market',
				component: () => import('@/views/market/MarketLayout'),
				hidden: true,
				meta: {
					title: '应用市场',
					keepAlive: true,
				},
				children: [
					{
						path: '/market/plugin',
						name: 'MarketPlugin',
						component: () => import('@/views/market/plugin'),
						hidden: true,
						meta: {
							title: '所有插件',
							keepAlive: true,
						},
					},
				],
			},
			// 账户
			{
				path: '/account',
				component: RouteView,
				hidden: true,
				meta: {
					title: '账户',
					keepAlive: false,
				},
				children: [
					{
						path: '/account/settings',
						component: () => import('@/views/account/settings/Index'),
						name: 'AccountSettings',
						meta: {
							title: '个人设置',
							keepAlive: false,
						},
						children: [
							{
								path: '/account/settings/security',
								component: () => import('@/views/account/settings/Security'),
								name: 'AccountSettingsSecurity',
								meta: {
									title: '安全设置',
									keepAlive: true,
								},
							},
							{
								path: '/account/settings/system',
								component: () => import('@/views/account/settings/System'),
								name: 'AccountSettingsSystem',
								meta: {
									title: '系统设置',
									keepAlive: true,
								},
							},
						],
					},
				],
			},
			//#region 
			// 收益倍增
			// {
			//   path: '/innovate/ecc',
			//   component: () => import('@/views/innovate/ecc'),
			//   name: 'InnovateEcc',
			//   hidden: config.production ? true : false,
			//   meta: { title: '收益倍增', icon: 'fund', keepAlive: true, hideChildrenInMenu: false }
			// },
			// 全网黑名单
			// {
			//   path: '/characteristic/blacklist',
			//   name: 'CharacteristicBlacklist',
			//   component: () => import('@/views/characteristic/blacklist'),
			//   meta: { title: '全网黑名单', keepAlive: false, icon: 'crown' }
			// },
			//菜鸟社群插件
			// {
			// 	path: '/rookie',
			// 	component: RouteView,
			// 	meta: {
			// 		title: '菜鸟社群插件',
			// 		icon: 'api',
			// 	},
			// 	children: [
			// 	    {
			// 	      path: '/rookie/basic-setting',
			// 	      name: 'basic-setting',
			// 	      component: () => import('@/views/rookie/basic-setting'),
			// 	      meta: { title: '基础设置', keepAlive: true }
			// 	    },
			// 		{
			// 			path: '/rookie/union',
			// 			name: 'union',
			// 			meta: { title: '联盟管理(暂不可用)' },
			// 			component: () => import('@/views/rookie/union')
			// 		  },
			// 		{
			// 			path: '/rookie/device',
			// 			name: 'device',
			// 			meta: { title: '设备管理' },
			// 			component: () => import('@/views/rookie/device')
			// 		  },
			// 		{
			// 		  path: '/rookie/group-management',
			// 		  name: 'group-management',
			// 		  component: () => import('@/views/rookie/group-management'),
			// 		  meta: { title: '群组管理', keepAlive: true }
			// 		},
			// 		{
			// 		  path: '/rookie/list-management',
			// 		  name: 'list-management',
			// 		  component: () => import('@/views/rookie/list-management'),
			// 		  meta: { title: '名单管理', keepAlive: true }
			// 		},
			// 		{
			// 		  path: '/rookie/group-function',
			// 		  name: 'group-function',
			// 		  component: () => import('@/views/rookie/group-function'),
			// 		  meta: { title: '群管功能', keepAlive: true }
			// 		},
			// 		// {
			// 		//   path: '/rookie/group-collection',
			// 		//   name: 'group-collection',
			// 		//   component: () => import('@/views/rookie/group-collection'),
			// 		//   meta: { title: '群采集发单', keepAlive: true }
			// 		// },
			// 		// {
			// 		//   path: '/rookie/warm-group',
			// 		//   name: 'warm-group',
			// 		//   hidden:true,
			// 		//   component: () => import('@/views/rookie/warm-group'),
			// 		//   meta: { title: '暖群功能', keepAlive: true }
			// 		// },
			// 		{
			// 			path: '/rookie/warm-groupJ',
			// 			name: 'warm-groupJ',
			// 			component: () => import('@/views/rookie/warm-groupJ'),
			// 			meta: { title: '暖群功能' ,keepAlive: false}
			// 		  },
			// 		{
			// 		  path: '/rookie/index',
			// 		  name: 'NuanQunBaoIndex',
			// 		  hidden: true,
			// 		  meta: { title: '剧本信息' },
			// 		  component: () => import('@/views/rookie/index')
			// 		},
			// 		{
			// 			path: '/rookie/edit',
			// 			name: 'NuanQunBaoEdit',
			// 			hidden: true,
			// 			meta: { title: '剧本信息',keepAlive: false},
			// 			component: () => import('@/views/rookie/modules/EditScript')
			// 		  },
			// 		{
			// 		  path: '/rookie/free-activities',
			// 		  name: 'free-activities',
			// 		  component: () => import('@/views/rookie/free-activities'),
			// 		  meta: { title: '免单活动(暂不可用)', keepAlive: true }
			// 		},


			// 		  {
			// 			path: '/rookie/DeviceInfo',
			// 			name: 'DeviceInfo',
			// 			hidden:true,
			// 			component: () => import('@/views/rookie/modules/DeviceInfo'),
			// 			meta: { title: '配置列表', keepAlive: false }
			// 		  },
			// 		{
			// 		  path: '/rookie/LoginCai',
			// 		  name: 'LoginCai',
			// 		  hidden: true,
			// 		  meta: { title: '登录'},
			// 		  component: () => import('@/views/rookie/LoginCai')
			// 		},
			// 		{
			// 			path: '/rookie/RegisterCai',
			// 			name: 'RegisterCai',
			// 			hidden: true,
			// 			meta: { title: '注册' },
			// 			component: () => import('@/views/rookie/RegisterCai')
			// 		  },
			// 		  {
			// 			path: '/rookie/ResetCai',
			// 			name: 'ResetCai',
			// 			hidden: true,
			// 			meta: { title: '忘记密码' },
			// 			component: () => import('@/views/rookie/ResetCai')
			// 		  },
			// 	  ]
			// },

			// 内测功能
			// {
			//   path: '/neice',
			//   redirect: '/dashboard-new/battle',
			//   component: RouteView,
			//   hidden: currentBrand.extend.includes('HideBug'),
			//   meta: { title: '内测功能', icon: 'bug'},
			//   children: [
			//     {
			//       path: '/dashboard-new/battle',
			//       name: 'BattleNew',
			//       component: () => import('@/views/dashboard-new/BattleNew'),
			//       meta: { title: '新作战室', keepAlive: true }
			//     }
			//   ]
			// }
			//#endregion
		],
	},
	{
		path: '*',
		redirect: '/404',
		hidden: true,
	},
]

/**
 * 基础路由
 * @type { *[] }
 */
export const constantRouterMap = [
	{
		path: '/user',
		component: UserLayout,
		redirect: '/user/login',
		hidden: true,
		children: [
			{
				path: 'login',
				name: 'login',
				component: () => import( /* webpackChunkName: "user" */ '@/views/user/Login'),
			},
			{
				path: 'register',
				name: 'register',
				component: () => import( /* webpackChunkName: "user" */ '@/views/user/Register'),
				meta: {
					keepAlive: false,
				},
				props: route => ({
					code: route.query.code,
				}),
			},
			{
				path: 'register-result',
				name: 'registerResult',
				component: () => import( /* webpackChunkName: "user" */ '@/views/user/RegisterResult'),
			},
			{
				path: 'reset',
				name: 'reset',
				component: () => import( /* webpackChunkName: "user" */ '@/views/user/Reset'),
				meta: {
					keepAlive: false,
				},
			},
		],
	},
	{
		path: '/direct',
		component: DirectLayout,
		hidden: true,
		children: [
			{
				path: 'fansdetail',
				name: 'FansDetail',
				component: () => import('@/views/direct/FansDetail'),
			},
		],
	},
	{
		path: '/iframe/userinfo',
		name: 'IframeUserInfo',
		component: () => import('@/views/fans/detail/iframeUserinfo'),
		hidden: true,
	},
	{
		path: '/404',
		component: () => import( /* webpackChunkName: "fail" */ '@/views/exception/404'),
	},
]
